import React from "react";
import { Helmet } from "react-helmet";
// TODO: remove once IE11 support deprecated
import "babel-polyfill"; // IE bug fix

import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import { QueryClientProvider } from "react-query";

import { config } from "@fortawesome/fontawesome-svg-core"
import { FetchProfile } from "./profile/FetchProfile";
import { FeatureFlagProvider } from "./contexts/FeatureFlagContext";
import { queryClient } from "./lib/queryClient";
import {
  Applications,
  ForgottenPassword,
  Login,
  LoginWithBreathe,
  AssociateSoftwareToken,
  ChangePassword,
  AccountNotConnected,
  MicrosoftCallback,
} from "./pages";
import { Layout } from "./components";
import { FetchTokens } from "./oauth/FetchTokens";

import useEnv from "./components/useEnv";

import "@fortawesome/fontawesome-svg-core/styles.css"

config.autoAddCss = false

const App = () => {
  const { isProd } = useEnv();
  const isAuthenticated = useStoreState((state) => state.isAuthenticated);
  const profile = useStoreState((state) => state.profile);

  return (
    <QueryClientProvider client={queryClient}>
      <FeatureFlagProvider>
        <Helmet>
          {!isProd && <meta name="robots" content="noindex" />}
        </Helmet>
        {isAuthenticated && <FetchProfile />}
        <Layout>
          <div
            className="w-full max-w-500 rounded-md bg-white relative mb-4 pt-10 box-shadow"
            role="main"
          >
            <img
              alt="companyLogo"
              src="/design/images/breathe_icon.svg"
              className="mx-auto h-16 w-auto"
            />
            <BrowserRouter>
              <Switch>
                <Route
                  path="/login"
                  render={() => {
                  return <Login />;
                }}
                />
                <Route
                  path="/oauth/authorize"
                  render={() => {
                  return <LoginWithBreathe />;
                }}
                />
                <Route
                  path="/forgotten-password"
                  render={() => {
                  return <ForgottenPassword />;
                }}
                />
                <Route
                  path="/oauth/authorize-callback"
                  render={(match) => {
                  const code = match.location.search.replace("?code=", "");

                  return <FetchTokens code={code} />;
                }}
                />
                <Route
                  path="/associate-software-token"
                  render={() => {
                  return <AssociateSoftwareToken email={profile.email} />;
                }}
                />

                <Route
                  path="/account-not-connected"
                  render={() => {
                  return <AccountNotConnected />;
                }}
                />

                <Route
                  path="/microsoft/callback"
                  render={() => {
                  return <MicrosoftCallback />;
                }}
                />

                <Route
                  path="/applications"
                  render={() => {
                  return isAuthenticated ? (
                    <Applications />
                  ) : (
                    <Redirect to="/login" />
                  );
                }}
                />
                <Route
                  path="/change-password"
                  render={() => {
                  return isAuthenticated ? (
                    <ChangePassword />
                  ) : (
                    <Redirect to="/login" />
                  );
                }}
                />

                <Redirect to="/login" />
              </Switch>
            </BrowserRouter>
          </div>
        </Layout>
      </FeatureFlagProvider>
    </QueryClientProvider>
  );
};

export default App;
